import { useAuth } from "@/context/AuthContext";
import StudentsManager from "@/components/StudentsManager";

export default function StudentsPage() {
  const { user } = useAuth();
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-extrabold text-slate-800">الطلاب</h1>
        <p className="text-slate-400">تصفية الطلاب حسب الصف والفصل والبحث بالاسم</p>
      </div>
      <StudentsManager schoolName={user?.school_name} />
    </div>
  );
}
